import styled, { ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { font, media } from '../theme/base/mixins';
import { StyledDivComponent } from '../types';
import { Icon } from './Icon';

interface OverlayContainerProps {
  show?: boolean;
}

type OverlayContainerPropsThemed = ThemeProps<Theme> & OverlayContainerProps;

export const OverlayContainer: StyledDivComponent<
  OverlayContainerProps
> = styled.div`
  display: ${(props: OverlayContainerPropsThemed) =>
    props.show ? 'block' : 'none'};
  border: 1px solid
    ${(props: OverlayContainerPropsThemed) => props.theme.colors.primary};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  position: fixed;
  background-color: white;
  right: 0;
  bottom: 30px;
  color: ${(props: OverlayContainerPropsThemed) => props.theme.colors.primary};
  z-index: 500;
  width: 100%;

  ${media.medium`
    max-width: 500px;
    right: 90px;
  `}
`;

export const OverlayContentWrapper: StyledDivComponent = styled.div`
  padding: 35px ${(props: ThemeProps<Theme>) => props.theme.grid.columnGap}px
    30px;

  ${media.medium`
    padding: 60px;
  `}
`;

export const OverlayHeader: StyledDivComponent = styled.div`
  ${font(3, 3.2, '500')};
  color: ${(props: ThemeProps<Theme>) => props.theme.colors.primary};
  margin-bottom: 20px;

  ${media.medium`
    margin-bottom: 30px;
  `}
`;

export const OverlayClose: StyledDivComponent = styled.div`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;

  ${Icon} {
    margin-right: 0;
    width: 24px;
    height: 24px;

    svg {
      fill: ${(props: ThemeProps<Theme>) => props.theme.colors.primary};
    }
  }
`;
